import React from 'react';
import styled from 'styled-components';
import LeftDashboardLoader from '../../Common/Loaders/LeftDashboardLoader';
import RightDashboardLoader from '../../Common/Loaders/RightDashboardLoader';

const DashboardLoader = () => {
	return (
		<StyledDashboard>
			<LeftDashboardStyled>
				<LeftDashboardLoader />
			</LeftDashboardStyled>
			<RightDashboardLoader />
		</StyledDashboard>
	);
};

const StyledDashboard = styled.div`
	padding-top: 6rem;
	display: flex;
`;

const LeftDashboardStyled = styled.section`
	width: 41.5rem;
	height: 100%;
	display: flex;
	justify-content: center;
	align-content: stretch;
	border: 1px solid ${(props) => props.theme.color[`grey300`]};
	background-color: ${(props) => props.theme.color[`white`]};
`;

export default DashboardLoader;
